import { useState, useEffect } from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link as ScrollLink } from "react-scroll";
import mainLogo from "../../Assets/icons/Logo_horizontal.webp";
import "../Home_css/navbar.css";

function Navbar2() {
  const [activeSection, setActiveSection] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [manualClick, setManualClick] = useState(false);
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/"; // home if URL path is "/"

  useEffect(() => {
    if (!autoScrollEnabled || manualClick) return;

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);

    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -50% 0px", // triggers when section is about halfway into view
      threshold: 0.3, // section is at least 30% visible
    };

    const observerCallback = (entries) => {
      let mostVisibleSection = null;
      let maxRatio = 0;
    
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
          mostVisibleSection = entry.target.id;
          maxRatio = entry.intersectionRatio;
        }
      });
    
      if (mostVisibleSection) {
        setActiveSection(mostVisibleSection);
      }
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    const sections = document.querySelectorAll("section");
    sections.forEach((section) => observer.observe(section));

    return () => {
      window.removeEventListener("scroll", handleScroll);
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [manualClick, autoScrollEnabled]);

  const handleNavClick = (section) => {
    setActiveSection(section);
    setManualClick(true);
    setAutoScrollEnabled(false);
    // Close the Navbar menu on mobile view
    setExpanded(false);
    // Update the URL hash (e.g., /#Products)
    window.history.pushState(null, "", `/#${section}`);
    setTimeout(() => {
      setManualClick(false);
      setAutoScrollEnabled(true);
    }, 1500);
  };
  // Navigation items (IDs on the HomePage must match these)
  const navItems = ["Products", "Treatments", "About", "Financing", "Events", "Contact"];

  return (
    <Navbar
  className={`custom-navbar ${scrolled ? "scrolled" : ""}`}
  expand="lg"
  expanded={expanded} // Control the expanded state
  onToggle={() => setExpanded(!expanded)} // Toggle menu open/close on hamburger click
>
      <Container>
        {/* Logo/Brand: Render ScrollLink or RouterLink based on route */}
        <Navbar.Brand className="logo">
          {isHome ? (
            <ScrollLink to="home" smooth={true} duration={500}>
              <img src={mainLogo} alt="Dahlia Health" className="logo-img" />
            </ScrollLink>
          ) : (
            <a href="https://dahliahealth.com/#home">
              <img src={mainLogo} alt="Dahlia Health" className="logo-img" />
            </a>
          )}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="w-100 justify-content-between align-items-center text-responsive-left">
        
            {navItems.map((section) =>
              isHome ? (
                <Nav.Link
                  key={section}
                  as={ScrollLink}
                  spy={true}
                  to={section}
                  smooth={true}
                  duration={100}
                  className={activeSection === section ? "active" : ""}
                  onClick={() => {
                    handleNavClick(section);
                    setExpanded(false); // Close the menu
                  }}
                >
                  {section}
                </Nav.Link>
              ) : (
                <Nav.Link
                  key={section}
                  as={RouterLink}
                  to={`/${section}`} // navigate to home with section hash when not on homepage
                  onClick={() => {
                    handleNavClick(section);
                    setExpanded(false); // Close the menu when clicked
                  }}
                  onToggle={() => setExpanded(!expanded)}
                >
                  {section}
                </Nav.Link>
              )
            )}
            
               <div className="nav-button ms-auto">
              <a href="https://shop.dahliahealth.com/">Online Shop</a>
              <a href="https://portal.dahliahealth.com/auth/signin">Log in</a>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbar2;
